<div class="registrationPaymentDiv">
  <odq-summary [model]="model" [selectedPremium] = "selectedPremium">
  </odq-summary>
  <button mat-raised-button  color="primary"
    (click)="doCredit()">
    {{'subscription.form.payment.confirmCredit' | translate}}
  </button>
  @if (isTransactionProcessing) {
    <div
      class="spinner-container">
      <mat-spinner></mat-spinner>
    </div>
  }
</div>
